import reframe, { subscription, parametric, pathSubscription } from 'nike-re-framejs';
import DataStateEnum from '@/common/dataState';
import { parseBoxId } from 'nike-ui/src/components/turboLive/push/utils';
import { Set } from 'immutable';

const detailLoadedId$ = pathSubscription(['nikeone', 'detail', '_loaded']);
export const detailData$ = pathSubscription(['nikeone', 'detail', 'data']);
reframe.regSub('nikeone.detail.sportEvent', db => db.getIn(['nikeone', 'detail', 'data', 'sportEvent']));
reframe.regSub('nikeone.detail.isLive', db => db.getIn(['nikeone', 'detail', 'data', 'sportEvent', 'isLive']));
reframe.regSub('nikeone.detail.market.tooltip', (db, [_, marketId]) =>
    db.getIn(['nikeone', 'detail', 'data', 'markets', marketId, 'infoTooltip'])
);

reframe.regSub('nikeone.detail.sportEventId', db =>
    db.getIn(['nikeone', 'detail', 'data', 'sportEvent', 'sportEventId'])
);

export const nikeoneDetailSportEventSportId$ = pathSubscription(['nikeone', 'detail', 'data', 'sportEvent', 'sportId']);

export const detailDataState$ = parametric(eventId =>
    subscription(
        (detail, loadedEventId) => {
            if (!detail || eventId !== loadedEventId) {
                return DataStateEnum.PENDING;
            }
            if (detail && (!detail.get('box') || !detail.getIn(['sportEvent', 'sportEventId']))) {
                return DataStateEnum.EMPTY;
            }

            return DataStateEnum.DATA;
        },
        detailData$,
        detailLoadedId$
    )
);

export const nike1DetailBet = parametric(betId =>
    subscription(detail => (detail ? detail.getIn(['bets', betId]) : null), detailData$)
);

export const detailLiveEvents = subscription(db => db.getIn(['nikeone', 'detail', 'statistics', 'live', 'liveEvents']));
export const detailLiveTeams = subscription(db => db.getIn(['nikeone', 'detail', 'statistics', 'live', 'teams']));

export const getResultScoreboard$$ = subscription(detail => {
    const selectedBetsHierarchy = detail?.getIn(['box', 'selectedBetsHierarchy']);
    if (selectedBetsHierarchy?.size) {
        const mainBetId = selectedBetsHierarchy
            ?.first()
            ?.first()
            ?.first()
            ?.get('betHeaders')
            ?.first()
            ?.get('sportEvents')
            ?.first()
            ?.get('betIds')
            ?.first();
        return detail.getIn(['bets', mainBetId, 'result']);
    }
    return null;
}, detailData$);

export const liveTournamentIds$$ = parametric(boxStore =>
    subscription(
        (liveTournamentIds, collapsedBoxIds) => {
            const collapsedTournamentIds = collapsedBoxIds
                ?.keySeq()
                ?.map(parseBoxId)
                .map(({ tournamentId }) => tournamentId);
            return liveTournamentIds.filter(tournamentId => !collapsedTournamentIds.contains(tournamentId));
        },
        pathSubscription(['nikeone', 'boxStore', boxStore, 'liveTournamentIds'], Set()),
        pathSubscription(['nikeone', 'boxStore', boxStore, 'filter', 'boxIds'], Set())
    )
);
